import { WorkflowStepProps } from "@/types/roadmap/roadmap.type"
import { FaLightbulb, FaBullseye, FaCode, FaFlask, FaPalette } from "react-icons/fa"

export const workflowStepsData: WorkflowStepProps[] = [
  {
    id: 1,
    key: "consultation",
    icon: FaLightbulb,
    image: "/assets/workflow-roadmap/consultation.png",
  },
  {
    id: 2,
    key: "planningDesign",
    icon: FaBullseye,
    image: "/assets/workflow-roadmap/planning-design.png",
  },
  {
    id: 3,
    key: "development",
    icon: FaCode,
    image: "/assets/workflow-roadmap/development.png",
  },
  {
    id: 4,
    key: "testing",
    icon: FaFlask,
    image: "/assets/workflow-roadmap/testing.png",
  },
  {
    id: 5,
    key: "launchSupport",
    icon: FaPalette,
    image: "/assets/workflow-roadmap/launch-support.png",
  },
]
